<template>
    <span>
        <div
            :class="{ 'editable': !readOnly}"
            @click="edit"
            v-html="editor"
            ref="header"
            v-if="mode == 'view'"
        ></div>

        <textarea
            class="editor"
            ref="editor"
            style="width: 100%"
            v-model="editor"
            v-if="mode == 'edit'"
            :placeholder="$t('content_placeholder')"
        ></textarea>

        <button v-if="mode == 'edit'" class="btn btn-sm btn-success" @click="save">{{ $t('save') }}</button>
        <button v-if="mode == 'edit'" class="btn btn-sm" @click="cancel">{{ $t('cancel') }}</button>
        <button v-if="mode == 'edit'" class="btn btn-sm btn-danger" @click="destroy">{{ $t('delete') }}</button>
        <br />
    </span>
</template>

<script>
    import widgetMixin from '../../mixins/widgetMixin.js';

    export default {
        mixins: [widgetMixin],
        props: {
            id: Number,
            readOnly: {
                type: Boolean,
                default: true,
            },
        },
        data: function () {
            return {
                mode: 'view',
                editor: '',
            }
        },
        computed: {
            contents: {
                set: function (value) {
                    this.widget.contents = value.replace(/\n/g, '<br />');
                },
                get: function () {
                    return this.widget.contents;
                }
            },
        },
        methods: {
            beforeSaveCallback: function () {
                this.contents = this.editor;
                this.mode = 'view';
            },

            edit: function () {
                if (this.readOnly) {
                    return false;
                }

                this.editor = this.contents || '';
                this.mode = 'edit';
            },

            cancel: function () {
                this.editor = this.widget.contents;
                this.mode = 'view';

                if (!this.contents) {
                    this.destroy(true);
                }
            },

            // resize: function () {
            //     this.$refs.editor.style.height = this.$refs.editor.scrollHeight + 'px';
            // },
        },
        mounted: function () {
            if (this.widget.contents == '' && !this.readOnly) {
                this.mode = 'edit';
            } else if (this.widget.contents) {
                this.editor = this.widget.contents;
            }
        },
        updated: function () {
            if (this.mode == 'edit') {
                var editor = this.$refs.editor;

                // editor.style.height = editor.scrollHeight + 'px';
                editor.focus();
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/widgets/HtmlWidget.vue